import { Box, Text } from '@wix/design-system';
import React from 'react';
import MoneyBackGuaranteeIcon from '../../../assets/icons/money-back-guarantee-checkout-icon.svg';
import { useCurrentModule } from '../../ModuleProvider';
export const CheckoutTrustBuilder = () => {
  var _isSwitchFlowQuery$da;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const isSwitchFlowQuery = module.SDK.switchApiClient.hooks.useIsSwitchFlow({});
  if (isSwitchFlowQuery.isLoading || (_isSwitchFlowQuery$da = isSwitchFlowQuery.data) != null && _isSwitchFlowQuery$da.isSwitchFlow) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "12px",
    align: "center",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(MoneyBackGuaranteeIcon, null), /*#__PURE__*/React.createElement(Text, {
    size: "medium"
  }, t('checkout.money_back_guarantee')));
};
//# sourceMappingURL=CheckoutTrustBuilder.js.map